import Component from './component'
import withContainer from './container'

export {
  Component,
  withContainer
}
export default withContainer(Component)
